import React from 'react'
import PropTypes from 'prop-types'

class Box extends React.Component {
  render() {
    return <div className={`box ${this.props.className}`}>{this.props.children}</div>
  }
}

Box.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}

export default Box
